module.exports = __webpack_public_path__ + "img/avatar3.545f8883.jpg";